<template>
  <vs-sidebar
    click-not-close
    hidden-background
    position-right
    v-model="dialogShow"
    class="items-no-padding edit-subib-rule-dialog sidebar-dialog">
    <div class="sidebar-content h-full">
      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6 " :settings="settings" :key="$vs.rtl">
        <div class="content px-6">
          <el-form
            ref="form"
            label-position="top"
            :model="form"
            :rules="rules"
          >
            <el-form-item
              :label="$t('Sub_IB_level_name')"
              prop="subIbLevelName"
            >
              <el-input
                disabled
                v-model="form.subIbLevelName"
              ></el-input>
            </el-form-item>
          </el-form>
          <commission-rule-group
            ref="rulegroup"
            :rule-data="subRuleData"
            :father-rule-data="fatherRuleData"
            @submit="ruleGroupSubmitHandle"
          ></commission-rule-group>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { editTMerchantCommissionLevelsRule } from '@/api/userCenter.js';
import commissionRuleGroup from "@/components/agent/propagandas/commissionRuleGroup";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default {
  name: "editSubIbRuleDialog",
  components:{
    VuePerfectScrollbar,
    commissionRuleGroup,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    subRuleData:{
      type: Array,
      default(){
        return []
      }
    },
    // 不用跟自己的规则对比,跟数组内最高的对比,字段(max);
    fatherRuleData:{
      type: Array,
      default(){
        return []
      }
    },
    currentSubIbInfo: {
      type: Object,
      default(){
        return {
          levelName: '',
          id: '',
        }
      },
    }
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('Modify_the_rebate_rules'),
      form: {
        subIbLevelName: _this.currentSubIbInfo.levelName,
      },
      rules: {
        subIbLevelName: [
          {required: true,}
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','themeColor']),
  },
  watch: {
    currentSubIbInfo(newValue, oldValue) {
      this.form.subIbLevelName = newValue.levelName;
    }
  },
  methods: {
    ruleGroupSubmitHandle(data) {
      editTMerchantCommissionLevelsRule({
        levelId: this.currentSubIbInfo.id,
        dataList: data,
      }).then((res) =>{
        this.$emit('edit-suceess');
        this.$message({
          type: 'success',
          message: this.$t('editSuceess')
        })
      })
    },
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.close();
    },
    submitHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          // 验证规则
          this.$refs.rulegroup.validateTable();
        }else {
          console.log('no-pass');
        }
      })
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.edit-subib-rule-dialog {
  .content {
  }
}
</style>
<style lang="scss">
.edit-subib-rule-dialog {
  .vs-sidebar--items {

  }
  // 高度滑动有点问题 todo
  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }
  .vs-sidebar {
    position: fixed;
    z-index: 999;
    .sidebar-content {
    }
  }
  .footer-sidebar {
    padding: 20px 0;
    padding-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
